<template>
  <b-tooltip
    :target="data_target"
    triggers="hover"
    custom-class="long-tooltip"
    placement="right"
    variant="dark"
  >
    You can specify the following parameterized value in the message template:
    <br />
    <!-- CUSTOMER SECTION -->
    <template v-if="!excludeCustomerSection">
      {{ firstNameParam }} - Customer’s first name <br />
      {{ lastNameParam }} - Customer’s last name <br />
      {{ memberIDParam }} - Customer’s member ID <br />
    </template>

    {{ monthParam }} - Current month name in Thai e.g. <strong>ส.ค.</strong>
    <br />
    {{ monthEnParam }} - Current month name in English e.g. <strong>Aug</strong>
    <br />
    {{ dateParam }} - Date in Thai of x days after the current date e.g.
    {{ dateSampleParam }} of 30 August 2023 will be replaced by
    <strong>2 ก.ย. 2566</strong>
    <br />
    {{ dateEnParam }} - Date in Thai of x days after the current date in English
    e.g. {{ dateSampleParam }} of 30 August 2023 will be replaced by
    <strong>2 Sep 2023</strong>
    <br />
    {{ lastDayParam }} - Last day of the current month e.g.
    <strong>31 ส.ค. 2566</strong>
    <br />
    {{ lastDayEnParam }} - Last day of the current month e.g.
    <strong>31 Aug 2023</strong>
    <br />
    <slot name="extra-message-field" />
  </b-tooltip>
</template>
<script>
export default {
  props: {
    data_target: {
      type: String,
      default: () => null,
    },
    excludeCustomerSection: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      firstNameParam: "{{firstname}}",
      lastNameParam: "{{lastname}}",
      memberIDParam: "{{memberID}}",
      monthParam: "{{month}}",
      monthEnParam: "{{month_en}}",
      dateParam: "{{T+x}}",
      dateEnParam: "{{T+x_en}}",
      dateSampleParam: "{{T+3}}",
      lastDayParam: "{{last day of the month}}",
      lastDayEnParam: "{{last day of the month_en}}",
    };
  },
};
</script>

<style lang="scss" scoped>
.long-tooltip::v-deep {
  .tooltip-inner {
    max-width: 600px !important;
    width: max-content !important;
    text-align: left;
  }
}
</style>
